export const QUERY_KEY_USER_UPLOAD = 'QUERY_KEY_USER_UPLOAD'
export const QUERY_KEY_USER_UPLOADS_LIST = 'QUERY_KEY_USER_UPLOADS_LIST'

export const MUTATION_KEY_VALIDATE_USER_UPLOAD =
  'MUTATION_KEY_VALIDATE_USER_UPLOAD'

export const MUTATION_KEY_CREATE_USER_UPLOAD =
  'MUTATION_KEY_CREATE_USER_UPLOAD'
